import { doc, updateDoc, serverTimestamp } from 'firebase/firestore'
import { db } from './firebase'
import { getDeviceInfo } from './deviceInfo'

/**
 * Logs device information to the user's Firestore document
 * Should be called once on app startup after user authentication
 */
export async function logDeviceInfoToFirestore(uid: string): Promise<void> {
  try {
    const deviceInfo = await getDeviceInfo()
    
    const userRef = doc(db, 'users', uid)
    await updateDoc(userRef, {
      deviceInfo: {
        platform: deviceInfo.platform,
        deviceType: deviceInfo.deviceType,
        appVersion: deviceInfo.appVersion,
        webVersion: deviceInfo.webVersion,
        loggedAt: serverTimestamp(),
        userAgent: deviceInfo.userAgent
      }
    })

    console.log('[DeviceLogging] Successfully logged device info for user:', uid)
  } catch (error) {
    console.error('[DeviceLogging] Failed to log device info:', error)
    // Don't throw - this shouldn't break app functionality
  }
}

/**
 * Updates device info for existing user (e.g., on app resume)
 * Optional: call this periodically or on app state changes
 */
export async function updateDeviceInfoInFirestore(uid: string): Promise<void> {
  try {
    const deviceInfo = await getDeviceInfo()
    
    const userRef = doc(db, 'users', uid)
    await updateDoc(userRef, {
      deviceInfo: {
        platform: deviceInfo.platform,
        deviceType: deviceInfo.deviceType,
        appVersion: deviceInfo.appVersion,
        webVersion: deviceInfo.webVersion,
        updatedAt: serverTimestamp(),
        userAgent: deviceInfo.userAgent
      }
    })

    console.log('[DeviceLogging] Successfully updated device info for user:', uid)
  } catch (error) {
    console.error('[DeviceLogging] Failed to update device info:', error)
  }
}

